<template>
  <section class="tablepo">
    <div class="tablepo__colstatic">
      <div class="tablepo__colstatic__empty">Equípos</div>

      <div class="tablepo__colstatic__shield-team ">
        <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + infoPosession[0].team_id + '.png'" />
      </div>
      <div class="tablepo__colstatic__shield-team">
        <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + infoPosession[1].team_id + '.png'" />
      </div>
    </div>
    <div class="tablepo__colscroll">
      <div class="tablepo__colscroll__wrapper">
        <div class="tablepo__colscroll__wrapper__col">
          <div class="tablepo__colscroll__wrapper__col__row-header">
            <div class="tablepo__colscroll__wrapper__col__row-header__item">
              Posesión con balón<br />
              en juego
            </div>
          </div>
          <div class="tablepo__colscroll__wrapper__col__row-subheader">
            <div class="tablepo__colscroll__wrapper__col__row-subheader__match">
              <div class="tablepo__colscroll__wrapper__col__row-subheader__match__item">
                <template v-if="type == 1">Este</template><template v-else>Último</template> partido
                <template v-if="type == 1">&nbsp;{{ changeMatch(matchday) }}</template>
              </div>
            </div>
            <div class="tablepo__colscroll__wrapper__col__row-subheader__prom">
              <div class="tablepo__colscroll__wrapper__col__row-subheader__match__item">Su promedio actual torneo</div>
            </div>
          </div>
          <div class="tablepo__colscroll__wrapper__col__row-value">
            <div class="tablepo__colscroll__wrapper__col__row-value__match-value">
              {{ infoPosession[0].ball_in_game }}
            </div>
            <div class="tablepo__colscroll__wrapper__col__row-value__prom-value">
              {{ infoPosession[0].season_ball_in_game_average }}
            </div>
          </div>
          <div class="tablepo__colscroll__wrapper__col__row-value">
            <div class="tablepo__colscroll__wrapper__col__row-value__match-value color-gray">
              {{ infoPosession[1].ball_in_game }}
            </div>
            <div class="tablepo__colscroll__wrapper__col__row-value__prom-value color-gray">
              {{ infoPosession[1].season_ball_in_game_average }}
            </div>
          </div>
        </div>
        <div class="tablepo__colscroll__wrapper__col">
          <div class="tablepo__colscroll__wrapper__col__row-header">
            <div class="tablepo__colscroll__wrapper__col__row-header__item">
              Posesión sin balón<br />
              en juego
            </div>
          </div>
          <div class="tablepo__colscroll__wrapper__col__row-subheader">
            <div class="tablepo__colscroll__wrapper__col__row-subheader__match">
              <div class="tablepo__colscroll__wrapper__col__row-subheader__match__item">
                <template v-if="type == 1">Este</template><template v-else>Último</template> partido&nbsp;<template
                  v-if="type == 1"
                  >{{ changeMatch(matchday) }}</template
                >
              </div>
            </div>
            <div class="tablepo__colscroll__wrapper__col__row-subheader__prom">
              <div class="tablepo__colscroll__wrapper__col__row-subheader__prom__item">Su promedio actual torneo</div>
            </div>
          </div>
          <div class="tablepo__colscroll__wrapper__col__row-value ">
            <div class="tablepo__colscroll__wrapper__col__row-value__match-value">
              {{ infoPosession[0].without_ball_in_game }}
            </div>
            <div class="tablepo__colscroll__wrapper__col__row-value__prom-value">
              {{ infoPosession[0].season_without_ball_in_game_average }}
            </div>
          </div>
          <div class="tablepo__colscroll__wrapper__col__row-value color-gray">
            <div class="tablepo__colscroll__wrapper__col__row-value__match-value color-gray">
              {{ infoPosession[1].without_ball_in_game }}
            </div>
            <div class="tablepo__colscroll__wrapper__col__row-value__prom-value color-gray">
              {{ infoPosession[1].season_without_ball_in_game_average }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TablePossession',
  components: {},
  props: {
    infoPosession: {
      type: Object,
      required: true,
    },
    type: {
      type: Number,
      default: 1,
      required: true,
    },
    matchday: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    changeMatch(match) {
      var mathtrans =
        match == 18
          ? 'CFI'
          : match == 19
          ? 'CFV'
          : match == 20
          ? 'SFI'
          : match == 21
          ? 'SFV'
          : match == 22
          ? 'FI'
          : match == 86
          ? 'FV'
          : match.replace('Matchday ', 'J');

      return mathtrans;
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.color-gray {
  background-color: #f6f8fb !important;
}
.tablepo {
  width: 100%;
  height: 302px;
  // background: palevioletred;
  display: inline-flex;
  justify-content: center;
  border-radius: 6px;
  border: solid 1px #b4c9dd;
  // background-color: #fff;
  overflow: hidden;
  &__colstatic {
    width: 23.26%;
    height: 302;
    // background: yellow;
    border-right: 1px solid #b4c9dd;
    &__empty {
      width: 100%;
      height: 154px;
      background: white;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-bottom: 1px solid #b4c9dd;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #132839;
      font-family: 'Avenir-Demi';
      @media screen and (max-width: 380px) {
        font-size: 14px;
      }
    }
    &__shield-team {
      background: white;
      height: 74px;
      width: 100%;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 28px;
      letter-spacing: normal;
      text-align: left;
      color: #132839;
      font-family: 'Avenir-Demi';
      padding-left: 5%;
      img {
        width: 40px;
      }
    }
  }
  &__colscroll {
    width: 76.74%;
    height: 302px;
    overflow-x: auto;
    overflow-y: hidden;
    // background: blueviolet;

    &__wrapper {
      width: 100%;
      height: 302px;
      // background: orangered;
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 520px) {
        width: 430px;
      }
      &__col {
        width: 50%;
        height: 302px;
        border-right: 1px solid #b4c9dd;
        &__row-header {
          width: 100%;
          height: 50px;
          background: #132739;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          border-bottom: 1px solid #feffff;

          &__item {
            width: 88%;
            height: auto;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.9;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            font-family: 'Avenir-Demi';
            &__text {
              font-family: 'Avenir-Regular';
            }
            @media screen and (max-width: 1030px) {
              width: 100%;
            }
            // @media screen and (max-width: 930px) {
            //   font-size: 11px;
            // }
          }
        }
        &__row-subheader {
          width: 100%;
          height: 104px;
          display: inline-flex;
          justify-content: space-between;
          align-content: center;
          align-items: center;
          // background: blue;
          &__match {
            width: 50%;
            height: 104px;
            background-color: #52a0fc;
            display: inline-flex;
            justify-content: center;
            align-content: center;
            border-right: solid 1px #b4c9dd;
            align-items: center;
            &__item {
              width: 88%;
              height: auto;
              font-size: 13px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.29;
              letter-spacing: normal;
              text-align: center;
              color: #fff;

              font-family: 'Avenir-Demi';
              &__text {
                font-family: 'Avenir-Regular';
              }
            }
          }
          &__prom {
            width: 50%;
            height: 104px;
            background-color: #4286d8;
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            &__item {
              width: 88%;
              height: auto;
              font-size: 13px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.29;
              letter-spacing: normal;
              text-align: center;
              color: #fff;
              font-family: 'Avenir-Demi';
              &__text {
                font-family: 'Avenir-Regular';
              }
            }
          }
        }
        &__row-value {
          width: 100%;
          height: 74px;
          display: inline-flex;
          justify-content: space-between;
          align-content: center;
          align-items: center;
          // background: blue;
          &__match-value {
            width: 50%;
            height: 74px;
            background-color: white;
            display: inline-flex;
            border-right: solid 1px #b4c9dd;
            line-height: 74px;
            justify-content: center;
            align-content: center;
            align-items: center;
            font-size: 14px;
            font-family: 'Avenir-Demi';
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;

            letter-spacing: normal;
            text-align: center;
            color: #132839;
          }
          &__prom-value {
            width: 50%;
            height: 74px;
            background-color: white;
            display: inline-flex;
            justify-content: center;
            line-height: 74px;
            align-content: center;
            align-items: center;
            font-family: 'Avenir-Demi';
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;

            letter-spacing: normal;
            text-align: center;
            color: #132839;
          }
        }
      }
    }
  }
}
</style>
